import styled from "@emotion/styled";

const MarkFormulaAsTemplateModalContent = styled.div({
  marginTop: "24px",
});

export { MarkFormulaAsTemplateModalContent };
